import { AnyAction } from "redux";
import {
  IBuyerComments,
  IDCStore,
  IOrderHistory,
  IStoreOrder,
  HISTORY_TAB,
  IUnitsQuantity,
} from "../../types/order.types";
import { IFilterOptions } from "../../types/filters.types";

export const SET_SELECTED_HISTORY_TAB = "SET_SELECTED_HISTORY_TAB";
export const GET_DC_STORE_DATA = "GET_DC_STORE_DATA";
export const GET_DC_STORE_DATA_SUCCESS = "GET_DC_STORE_DATA_SUCCESS";
export const GET_DC_STORE_DATA_ERROR = "GET_DC_STORE_DATA_ERROR";
export const GET_STORE_ORDER_DATA = "GET_STORE_ORDER_DATA";
export const GET_STORE_ORDER_DATA_SUCCESS = "GET_STORE_ORDER_DATA_SUCCESS";
export const GET_STORE_ORDER_DATA_ERROR = "GET_STORE_ORDER_DATA_ERROR";
export const GET_BUYER_COMMENTS_DATA = "GET_BUYER_COMMENTS_DATA";
export const GET_BUYER_COMMENTS_DATA_SUCCESS =
  "GET_BUYER_COMMENTS_DATA_SUCCESS";
export const GET_BUYER_COMMENTS_DATA_ERROR = "GET_BUYER_COMMENTS_DATA_ERROR";
export const GET_DC_STORE_TOTAL = "GET_DC_STORE_TOTAL";
export const GET_DC_STORE_TOTAL_SUCCESS = "GET_DC_STORE_TOTAL_SUCCESS";
export const GET_DC_STORE_TOTAL_ERROR = "GET_DC_STORE_TOTAL_ERROR";
export const GET_STORE_ORDER_TOTAL = "GET_STORE_ORDER_TOTAL";
export const GET_STORE_ORDER_TOTAL_SUCCESS = "GET_STORE_ORDER_TOTAL_SUCCESS";
export const GET_STORE_ORDER_TOTAL_ERROR = "GET_STORE_ORDER_TOTAL_ERROR";
export const DC_STORE_FILTERED_DATA = "DC_STORE_FILTERED_DATA";
export const STORE_ORDER_FILTERED_DATA = "STORE_ORDER_FILTERED_DATA";
export const VALUES_IN_STATE = "VALUES_IN_STATE";
export const SELECTED_VALUES_STORE_ORDER = "SELECTED_VALUES_STORE_ORDER";
export const SET_IS_EXPANDED_VIEW_OPEN = "SET_IS_EXPANDED_VIEW_OPEN";
export const RESET_ORDER_HISTORY = "RESET_ORDER_HISTORY";
export const RESET_EXPAND_MODE_DC_STORE_FILTER =
  "RESET_EXPAND_MODE_DC_STORE_FILTER";
export const RESET_EXPAND_MODE_STORE_ORDER_FILTER =
  "RESET_EXPAND_MODE_STORE_ORDER_FILTER";

export interface IOrderHistoryReducer {
  selectedHistoryTab: HISTORY_TAB;
  isLoadedDcStoreData: boolean;
  isLoadingDcStoreData: boolean;
  dcStoreData: IDCStore[] | IOrderHistory[];
  dcStoreFilteredData: IDCStore[] | IOrderHistory[];
  totalDcStoreQuantity: IUnitsQuantity;
  isLoadedStoreOrderData: boolean;
  isLoadingStoreOrderData: boolean;
  storeOrderData: IStoreOrder[];
  storeOrderFilteredData: IStoreOrder[];
  totalStoreOrderQuantity: IUnitsQuantity;
  isLoadedBuyerCommentsData: boolean;
  isLoadingBuyerCommentsData: boolean;
  buyerCommentsData: IBuyerComments | null;
  filteredTotal: any;
  selectedvalues: any;
  selectedvaluesStoreOrder: any;
  isExpandedViewOpen: boolean;
}

export const selectedValuesState = (value: any) => ({
  type: VALUES_IN_STATE,
  value,
});

export const selectedValuesStoreOrderState = (value: any) => ({
  type: SELECTED_VALUES_STORE_ORDER,
  value,
});

export const setSelectedHistoryTab = (value: HISTORY_TAB) => ({
  type: SET_SELECTED_HISTORY_TAB,
  value,
});

export const setDcStoreFilteredValues = (
  value: IDCStore[] | IOrderHistory[],
) => ({
  type: DC_STORE_FILTERED_DATA,
  value,
});

export const setStoreOrderFilteredValues = (value: IStoreOrder[]) => ({
  type: STORE_ORDER_FILTERED_DATA,
  value,
});

export const fetchDcStoreData = (filters: IFilterOptions) => ({
  type: GET_DC_STORE_DATA,
  value: {
    filters,
  },
});

export const fetchDcStoreDataSuccess = (
  data: IDCStore[] | IOrderHistory[],
) => ({
  type: GET_DC_STORE_DATA_SUCCESS,
  value: {
    data,
  },
});

export const fetchDcStoreDataError = () => ({
  type: GET_DC_STORE_DATA_ERROR,
});

export const fetchStoreOrderData = (filters: IFilterOptions) => ({
  type: GET_STORE_ORDER_DATA,
  value: {
    filters,
  },
});

export const fetchStoreOrderDataSuccess = (data: IStoreOrder[]) => ({
  type: GET_STORE_ORDER_DATA_SUCCESS,
  value: {
    data,
  },
});

export const fetchStoreOrderDataError = () => ({
  type: GET_STORE_ORDER_DATA_ERROR,
});

export const fetchBuyerCommentsData = (filters: IFilterOptions) => ({
  type: GET_BUYER_COMMENTS_DATA,
  value: {
    filters,
  },
});

export const fetchBuyerCommentsDataSuccess = (value: IBuyerComments) => ({
  type: GET_BUYER_COMMENTS_DATA_SUCCESS,
  value,
});

export const fetchBuyerCommentsDataError = () => ({
  type: GET_BUYER_COMMENTS_DATA_ERROR,
});

export const fetchDcStoreTotal = (filters: IFilterOptions) => ({
  type: GET_DC_STORE_TOTAL,
  value: {
    filters,
  },
});

export const fetchDcStoreTotalSuccess = (totals: IUnitsQuantity) => ({
  type: GET_DC_STORE_TOTAL_SUCCESS,
  value: totals,
});

export const fetchDcStoreTotalError = () => ({
  type: GET_DC_STORE_TOTAL_ERROR,
});

export const fetchStoreOrderTotal = (filters: IFilterOptions) => ({
  type: GET_STORE_ORDER_TOTAL,
  value: {
    filters,
  },
});

export const fetchStoreOrderTotalSuccess = (totals: IUnitsQuantity) => ({
  type: GET_STORE_ORDER_TOTAL_SUCCESS,
  value: totals,
});

export const fetchStoreOrderTotalError = () => ({
  type: GET_STORE_ORDER_TOTAL_ERROR,
});

export const setIsExpandedViewOpen = (value: boolean) => ({
  type: SET_IS_EXPANDED_VIEW_OPEN,
  value,
});

export const resetOrderHistory = () => ({
  type: RESET_ORDER_HISTORY,
});

export const resetExpandModeDCStoreFilter = () => ({
  type: RESET_EXPAND_MODE_DC_STORE_FILTER,
  value: {
    selectedPOs: [],
    selectedDates: [],
    selectedStatus: [],
    quantityValueFirstSelect: { label: "-Select-", value: undefined },
    quantityValueFirstValue: undefined,
    quantityValueSecondSelect: { label: "-Select-", value: undefined },
    quantityValueSecondValue: undefined,
    radioValue: "&&",
  },
});

export const resetExpandModeStoreOrderFilter = () => ({
  type: RESET_EXPAND_MODE_STORE_ORDER_FILTER,
  value: {
    selectedOrderIds: [],
    selectedDates: [],
    selectedStatus: [],
    quantityValueFirstSelect: { label: "-Select-", value: undefined },
    quantityValueFirstValue: undefined,
    quantityValueSecondSelect: { label: "-Select-", value: undefined },
    quantityValueSecondValue: undefined,
    radioValue: "&&",
  },
});

export const initialState: IOrderHistoryReducer = {
  selectedHistoryTab: HISTORY_TAB.DC_ORDER,
  isLoadedDcStoreData: false,
  isLoadingDcStoreData: false,
  dcStoreData: [],
  dcStoreFilteredData: [],
  totalDcStoreQuantity: {
    sellingUnits: 0,
    shippingUnits: 0,
    vendorUnits: 0,
  },
  isLoadedStoreOrderData: false,
  isLoadingStoreOrderData: false,
  storeOrderData: [],
  storeOrderFilteredData: [],
  totalStoreOrderQuantity: {
    sellingUnits: 0,
    shippingUnits: 0,
    vendorUnits: 0,
  },
  isLoadedBuyerCommentsData: false,
  isLoadingBuyerCommentsData: false,
  buyerCommentsData: null,
  filteredTotal: "",
  selectedvalues: {
    selectedPOs: [],
    selectedDates: [],
    selectedStatus: [],
    quantityValueFirstSelect: { label: "-Select-", value: undefined },
    quantityValueFirstValue: undefined,
    quantityValueSecondSelect: { label: "-Select-", value: undefined },
    quantityValueSecondValue: undefined,
    radioValue: "&&",
  },
  selectedvaluesStoreOrder: {
    selectedOrderIds: [],
    selectedDates: [],
    selectedStatus: [],
    quantityValueFirstSelect: { label: "-Select-", value: undefined },
    quantityValueFirstValue: undefined,
    quantityValueSecondSelect: { label: "-Select-", value: undefined },
    quantityValueSecondValue: undefined,
    radioValue: "&&",
  },
  isExpandedViewOpen: false,
};

export const orderHistoryReducer = (
  state = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case SET_SELECTED_HISTORY_TAB:
      return {
        ...state,
        selectedHistoryTab: action.value,
      };
    case GET_DC_STORE_DATA:
      return {
        ...state,
        isLoadedDcStoreData: false,
        isLoadingDcStoreData: true,
        dcStoreData: [],
        dcStoreFilteredData: [],
      };
    case GET_DC_STORE_DATA_SUCCESS: {
      return {
        ...state,
        isLoadedDcStoreData: true,
        isLoadingDcStoreData: false,
        dcStoreData: action.value.data,
        dcStoreFilteredData: action.value.data,
      };
    }
    case GET_DC_STORE_DATA_ERROR: {
      return {
        ...state,
        isLoadedDcStoreData: true,
        isLoadingDcStoreData: false,
        dcStoreData: [],
        dcStoreFilteredData: [],
      };
    }
    case DC_STORE_FILTERED_DATA:
      return {
        ...state,
        dcStoreFilteredData: action.value,
      };
    case GET_STORE_ORDER_DATA:
      return {
        ...state,
        isLoadedStoreOrderData: false,
        isLoadingStoreOrderData: true,
        storeOrderData: [],
        storeOrderFilteredData: [],
      };
    case GET_STORE_ORDER_DATA_SUCCESS:
      return {
        ...state,
        isLoadedStoreOrderData: true,
        isLoadingStoreOrderData: false,
        storeOrderData: action.value.data,
        storeOrderFilteredData: action.value.data,
      };
    case GET_STORE_ORDER_DATA_ERROR:
      return {
        ...state,
        isLoadedStoreOrderData: true,
        isLoadingStoreOrderData: false,
        storeOrderData: [],
        storeOrderFilteredData: [],
      };
    case STORE_ORDER_FILTERED_DATA:
      return {
        ...state,
        storeOrderFilteredData: action.value,
      };
    case GET_BUYER_COMMENTS_DATA:
      return {
        ...state,
        isLoadedBuyerCommentsData: false,
        isLoadingBuyerCommentsData: true,
        buyerCommentsData: null,
      };
    case GET_BUYER_COMMENTS_DATA_SUCCESS:
      return {
        ...state,
        isLoadedBuyerCommentsData: true,
        isLoadingBuyerCommentsData: false,
        buyerCommentsData: action.value,
      };
    case GET_BUYER_COMMENTS_DATA_ERROR:
      return {
        ...state,
        isLoadedBuyerCommentsData: true,
        isLoadingBuyerCommentsData: false,
        buyerCommentsData: null,
      };
    case GET_DC_STORE_TOTAL:
      return {
        ...state,
        totalDcStoreQuantity: {
          sellingUnits: 0,
          shippingUnits: 0,
          vendorUnits: 0,
        },
      };
    case GET_DC_STORE_TOTAL_SUCCESS:
      return {
        ...state,
        totalDcStoreQuantity: action.value,
      };
    case GET_DC_STORE_TOTAL_ERROR:
      return {
        ...state,
        totalDcStoreQuantity: {
          sellingUnits: 0,
          shippingUnits: 0,
          vendorUnits: 0,
        },
      };
    case GET_STORE_ORDER_TOTAL:
      return {
        ...state,
        totalStoreOrderQuantity: {
          sellingUnits: 0,
          shippingUnits: 0,
          vendorUnits: 0,
        },
      };
    case GET_STORE_ORDER_TOTAL_SUCCESS:
      return {
        ...state,
        totalStoreOrderQuantity: action.value,
      };
    case GET_STORE_ORDER_TOTAL_ERROR:
      return {
        ...state,
        totalStoreOrderQuantity: {
          sellingUnits: 0,
          shippingUnits: 0,
          vendorUnits: 0,
        },
      };
    case SET_IS_EXPANDED_VIEW_OPEN:
      return {
        ...state,
        isExpandedViewOpen: action.value,
      };
    case VALUES_IN_STATE:
      return {
        ...state,
        selectedvalues: action.value,
      };
    case RESET_EXPAND_MODE_DC_STORE_FILTER:
      return {
        ...state,
        selectedvalues: action.value,
      };
    case RESET_EXPAND_MODE_STORE_ORDER_FILTER:
      return {
        ...state,
        selectedvaluesStoreOrder: action.value,
      };
    case SELECTED_VALUES_STORE_ORDER:
      return {
        ...state,
        selectedvaluesStoreOrder: action.value,
      };
    case RESET_ORDER_HISTORY:
      return {
        ...state,
        isLoadedDcStoreData: false,
        isLoadedStoreOrderData: false,
        isLoadedBuyerCommentsData: false,
      };
    default:
      return state;
  }
};

export default orderHistoryReducer;
